import { twMerge } from "tailwind-merge";
import { usePopupAnimation } from "@hooks/usePopupAnimation";

interface NavMenuProps {
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
}

export const NavMenu = ({ isOpen, children, className }: NavMenuProps) => {
  const { isVisible, shouldRender } = usePopupAnimation(isOpen);

  if (!shouldRender) return null;
  return (
    <div
      className={twMerge(
        "absolute top-15 -right-3.5 z-10 rounded-xl bg-secondary-700 p-6",
        "shadow-lg",
        "transition-opacity duration-300",
        'after:absolute after:-top-2 after:right-7 after:h-[20px] after:w-[20px] after:rotate-45 after:bg-secondary-700 after:content-[""]',
        "dark:bg-tertiary-950 dark:after:bg-tertiary-950",
        isVisible ? "opacity-100" : "opacity-0",
        className
      )}
    >
      {children}
    </div>
  );
};
